export default __webpack_public_path__ + "static/media/template_daily.00a76062.png";